import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Noto_Serif%22,%22arguments%22:[{%22subsets%22:[%22latin%22,%22latin-ext%22,%22cyrillic%22,%22cyrillic-ext%22,%22greek%22,%22greek-ext%22],%22display%22:%22swap%22,%22preload%22:false,%22variable%22:%22--font-noto-serif%22}],%22variableName%22:%22notoSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Noto Serif', 'Noto Serif Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
